import { apiClient } from './client';

export interface TenantSummary {
  id: string;
  slug: string;
  brandName: string | null;
  status: string;
  operators: number;
  clients: number;
}

export interface CreateTenantBody {
  slug: string;
  brandName: string;
  primaryColor?: string;
  accentColor?: string;
  welcomeText?: string;
  adminUsername: string;
  adminPassword: string;
}

export interface CreateTenantResult {
  tenantId: string;
  slug: string;
  adminUsername: string;
  inviteBaseUrl: string;
}

export interface UpdateTenantBody {
  brandName?: string;
  primaryColor?: string;
  accentColor?: string;
  welcomeText?: string;
  status?: 'active' | 'suspended';
}

export const tenantsApi = {
  list: async (): Promise<TenantSummary[]> => {
    const { data } = await apiClient.get('/super-admin/tenants');
    return data as TenantSummary[];
  },

  create: async (body: CreateTenantBody): Promise<CreateTenantResult> => {
    const { data } = await apiClient.post('/super-admin/tenants', body);
    return data as CreateTenantResult;
  },

  update: async (id: string, body: UpdateTenantBody): Promise<{ ok: true }> => {
    const { data } = await apiClient.patch(`/super-admin/tenants/${id}`, body);
    return data as { ok: true };
  },

  uploadLogo: async (tenantId: string, file: File): Promise<{ logoUrl: string }> => {
    const form = new FormData();
    form.append('file', file);
    form.append('tenantId', tenantId);
    const { data } = await apiClient.post('/admin/branding/logo', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data as { logoUrl: string };
  },
};
